export enum SignalRSendEvent {
    JoinGroup
}

export enum SignalRReceiveEvent {
    UpdateStatus
}